<template>
  <DialogTemplateToolkit
    ref="dialog"
    :dialog.sync="dialog"
    :disabled="disabled"
    first_btn="Common.Save"
    :title="$t('Purchasing.ChangDate')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <MenuItem
        class="h11-links"
        icon="calendar"
        :label="$t('Purchasing.ToChangDate')"
        @click="open"/>
    </template>
    <template #card-text>
      <div class="secondary__green_chosen pa-4">
        <div
          v-if="item.resource"
          class="h7-text secondary__green_not_active--text">
          {{ item.resource.category ? item.resource.category.code : '' }}
          {{ item.resource.category ? item.resource.category.name :
            item.resource.group ? item.resource.group.name
            : '' }}
        </div>
        <span class="h8-text black--text">
          {{ item.resource ? item.resource.name : item.resourceName }}
        </span>
      </div>
      <div class="flex wrap align-start pt-4 pb-2">
        <div class="width-100">
          {{ $t('Purchasing.NewDate') }}
          <DateRadioMenu
            :date.sync="date"/>
        </div>
        <div class="width-100 mt-4">
          {{ $t('Purchasing.WhyChange') }}
          <sInput
            autofocus
            clearable
            :max-length="4000"
            max-rows="5"
            rows="5"
            type="textarea"
            :value.sync="text"/>
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DateRadioMenu from 'components/common/blocks/DateRadioMenu.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'changeDate',
  mixins: [modalMixin],
  data() {
    return {
      dialog: false,
      date: '',
      text: ''
    }
  },
  props: {
    elements: Array,
  },
  created() {
    this.date = this.item.approvedPriority?.id || (!this.item.approvedSupplyDate ? '' : this.item.approvedSupplyDate) ||  (!this.item.declaredSupplyDate ? '' : this.item.declaredSupplyDate) || ''
  },
  computed: {
    disabled() {
      return this.date == 0  || !this.commentRule(this.text, true)
    },
    item: {
      get() {
        return this.elements[0] || {}
      },
      set(value) {
        this.$emit('update:elements', [value])
      }
    },
  },
  methods: {
    apply() {
      if (this.date.length > 1) {
        this.$emit('callback', this.item.quantity, this.text, '', this.date)
      } else {
        this.$emit('callback', this.item.quantity, this.text, this.date , '')
      }
      this.text = ''
      this.close()
    },
    open() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
  },
  components: {
    MenuItem,
    DateRadioMenu,
    DialogTemplateToolkit
  }
}
</script>
